import React, { useEffect, useState } from 'react'
import '../AnnouncmentManagement/Annoucement.css'
import { Link, useNavigate, useParams } from 'react-router-dom'
import LoaderHelper from '../../../customComponents/Loading/LoaderHelper';
import AuthService from '../../../api/services/AuthService';
import moment from 'moment';

import { STATIC_CATEGORIES, STATIC_ANNOUNCEMENTS, toAgcxCopy } from './staticAnnouncements';

function AnnouncementList() {
    const navigate = useNavigate();
    const [announcementList, setAnnouncementList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const { announce_title_id, title } = useParams()
    const readableTitle = title?.replace(/_/g, " ");

    const tabsRef = React.useRef(null);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(false);

    const handleScroll = () => {
        if (tabsRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = tabsRef.current;
            setShowLeftArrow(scrollLeft > 0);
            setShowRightArrow(Math.ceil(scrollLeft + clientWidth) < scrollWidth);
        }
    };

    useEffect(() => {
        handleScroll();
        window.addEventListener("resize", handleScroll);
        return () => window.removeEventListener("resize", handleScroll);
    }, []);

    useEffect(() => {
        if (announce_title_id) {
            handleScroll();
        }
    }, [categoryList, announce_title_id]);

    const scrollTabs = (direction) => {
        if (tabsRef.current) {
            tabsRef.current.scrollBy({ left: direction === 'left' ? -200 : 200, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (announce_title_id) {
            handleAnnounceList(readableTitle, announce_title_id);

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [announce_title_id]);

    const handleAnnounceList = async (readableTitle, announce_title_id) => {

        navigate(`/announcement_list/${readableTitle}/${announce_title_id}`)
        LoaderHelper.loaderStatus(true);
        try {
            if (!announce_title_id) {
                LoaderHelper.loaderStatus(false);
                return;
            }
            if (String(announce_title_id).startsWith("cat_")) {
                LoaderHelper.loaderStatus(false);
                const filtered = STATIC_ANNOUNCEMENTS.filter(item => item.categoryId === announce_title_id);
                setAnnouncementList(filtered);
                return;
            }

            const result = await AuthService.getAnnouncementList(announce_title_id);
            LoaderHelper.loaderStatus(false);
            if (result?.success && result?.data && result?.data.length > 0) {
                setAnnouncementList(result.data.reverse().map((item) => ({
                    ...item,
                    title: toAgcxCopy(item?.title),
                    description: toAgcxCopy(item?.description),
                })));
            } else {
                const matchedStaticCategory = STATIC_CATEGORIES.find(
                    c => c.title.toLowerCase() === String(readableTitle || "").toLowerCase()
                );
                const categoryIdToSearch = matchedStaticCategory ? matchedStaticCategory._id : announce_title_id;
                const filtered = STATIC_ANNOUNCEMENTS.filter(item => item.categoryId === categoryIdToSearch);
                setAnnouncementList(filtered);
            }
        } catch (err) {
            LoaderHelper.loaderStatus(false);
            const matchedStaticCategory = STATIC_CATEGORIES.find(
                c => c.title.toLowerCase() === String(readableTitle || "").toLowerCase()
            );
            const categoryIdToSearch = matchedStaticCategory ? matchedStaticCategory._id : announce_title_id;
            const filtered = STATIC_ANNOUNCEMENTS.filter(item => item.categoryId === categoryIdToSearch);
            setAnnouncementList(filtered);
        }
    };

    useEffect(() => {
        handleCategoryAnnouncement();
    }, []);

    const handleCategoryAnnouncement = async () => {
        LoaderHelper.loaderStatus(true);
        try {
            const result = await AuthService.getAnnouncementCategoryList();
            LoaderHelper.loaderStatus(false);
            if (result?.success && result?.data && result?.data.length > 0) {
                setCategoryList(result.data.map((item) => ({
                    ...item,
                    title: toAgcxCopy(item?.title),
                    description: toAgcxCopy(item?.description),
                })));
            } else {
                setCategoryList(STATIC_CATEGORIES);
            }
        } catch (err) {
            LoaderHelper.loaderStatus(false);
            setCategoryList(STATIC_CATEGORIES);
        }
    };



    return (
        <>

            <section className="announcement_section single_announcement">
                <div className="container">
                    <h1>
                        <img
                            src="/images/AnnouncementImg/back_btn.png"
                            alt="back btn"
                            style={{ cursor: "pointer", marginRight: "10px" }}
                            onClick={() => navigate("/announcement")} // 👈 goes back to previous page
                        />
                        Announcement Details
                    </h1>

                    <div className="d-flex justify-content-between align-items-center mt-4">

                        <div className="announcement_tabs_container" style={{ position: 'relative', maxWidth: '100%', display: 'flex', alignItems: 'center' }}>
                            {showLeftArrow && (
                                <button className="dock_scroll_btn left" onClick={() => scrollTabs('left')}>
                                    &#10094;
                                </button>
                            )}
                            <ul className="nav nav-tabs announcement_tabs" id="announcementTabs" ref={tabsRef} onScroll={handleScroll}>
                                {categoryList?.map((item, index) => {
                                    const formattedTitle = item?.title
                                        ?.trim()
                                        ?.replace(/\s+/g, "_")        // space -> underscore
                                        ?.slice(0, 50)                // limit to 50 chars
                                        ?.replace(/_+$/, "");         // remove trailing underscores

                                    return (
                                        <li className="nav-item" role="presentation" key={item?._id || index}>
                                            <button className={`nav-link ${item?.title === readableTitle ? "active" : ""}`} id={item?.id} onClick={() => handleAnnounceList(formattedTitle, item?._id)}>
                                                {item?.title}
                                            </button>
                                        </li>
                                    )
                                })}
                            </ul>
                            {showRightArrow && (
                                <button className="dock_scroll_btn right" onClick={() => scrollTabs('right')}>
                                    &#10095;
                                </button>
                            )}
                        </div>

                        {/* 
                        <div className="search_info">
                            <button><img src="/images/AnnouncementImg/search_icon.png" alt="search" /></button>
                            <input type="text" placeholder="Search" />
                        </div> */}
                    </div>


                    <div className="tab-content announcement_content" id="announcementTabsContent">

                        <div className="tab-pane fade show active" id="crypto" role="tabpanel" aria-labelledby="crypto-tab">
                            <h3 className="text-white">{readableTitle}</h3>

                            <div className="crypto_listing_cnt">
                                {announcementList && announcementList.length > 0 ? (
                                    announcementList.map((announcement) => {
                                        const formattedTitle = announcement?.title
                                            ?.trim()
                                            ?.replace(/\s+/g, "_") // replace spaces with underscores
                                            ?.slice(0, 50) // limit to 50 characters
                                            ?.replace(/_+$/, ""); // remove trailing underscores

                                        return (
                                            <div className="block_listing" key={announcement?._id}>
                                                <h5>
                                                    <Link to={`/announcement_details/${formattedTitle}/${announcement?._id}`}>
                                                        {announcement?.title}
                                                    </Link>
                                                </h5>
                                                <span className="small">
                                                    {moment(announcement.createdAt).format("DD-MM-YYYY")}
                                                </span>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="announcement-list-empty" role="status">
                                        <div className="announcement-empty-inner">
                                            <div className="announcement-empty-illustration">
                                                <img src="/images/no_data_vector.svg" className="img-fluid" width={96} height={96} alt="" />
                                            </div>
                                            <p className="announcement-empty-text">No announcements found.</p>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* 
                            <nav className="pagination">
                                <ul className="justify-content-center">
                                    <li className="page-item disabled"><a className="page-link" href="#" tabIndex="-1" ariaDisabled="true">
                                    </a>
                                    </li>
                                    <li className="page-item active"><a className="page-link" href="#">1</a></li>
                                    <li className="page-item"><a className="page-link" href="#">2</a></li>
                                    <li className="page-item"><a className="page-link" href="#">3</a></li>
                                    <li className="page-item"><a className="page-link" href="#">4</a></li>
                                </ul>
                            </nav> */}

                        </div>

                        <div className="tab-pane fade" id="news" role="tabpanel" aria-labelledby="news-tab">
                            <h3 className="text-white">Latest News</h3>

                            <div className="crypto_listing_cnt">
                                <div className="block_listing">
                                    <h5>AGCX Is Licensed by the UAE Capital Markets Authority</h5>
                                    <span className="small">2026-08-11</span>
                                </div>
                                <div className="block_listing">
                                    <h5>KYC with Emirates ID or Passport Is Required for Withdrawals</h5>
                                    <span className="small">2026-08-07</span>
                                </div>
                                <div className="block_listing">
                                    <h5>AGCX Proof of Reserves Report Is Available</h5>
                                    <span className="small">2026-08-03</span>
                                </div>
                            </div>

                            <nav className="pagination">
                                <ul className="justify-content-center">
                                    <li className="page-item disabled"><a className="page-link" href="#" tabIndex="-1" ariaDisabled="true">
                                    </a>
                                    </li>
                                    <li className="page-item active"><a className="page-link" href="#">1</a></li>
                                    <li className="page-item"><a className="page-link" href="#">2</a></li>
                                    <li className="page-item"><a className="page-link" href="#">3</a></li>
                                    <li className="page-item"><a className="page-link" href="#">4</a></li>
                                </ul>
                            </nav>

                        </div>

                        <div className="tab-pane fade" id="activities" role="tabpanel" aria-labelledby="activities-tab">
                            <h3 className="text-white">Latest Activities</h3>

                            <div className="crypto_listing_cnt">
                                <div className="block_listing">
                                    <h5>AGCX Launchpad: Subscribe to Upcoming Token Sales</h5>
                                    <span className="small">2026-08-10</span>
                                </div>
                                <div className="block_listing">
                                    <h5>Simple Earn and Soft Staking Are Live on AGCX</h5>
                                    <span className="small">2026-08-06</span>
                                </div>
                                {/* <div className="block_listing">
                                    <h5>P2P: Buy and Sell USDT with AED Local Payments</h5>
                                    <span className="small">2026-08-01</span>
                                </div> */}
                            </div>

                            <nav className="pagination">
                                <ul className="justify-content-center">
                                    <li className="page-item disabled"><a className="page-link" href="#" tabIndex="-1" ariaDisabled="true">
                                    </a>
                                    </li>
                                    <li className="page-item active"><a className="page-link" href="#">1</a></li>
                                    <li className="page-item"><a className="page-link" href="#">2</a></li>
                                    <li className="page-item"><a className="page-link" href="#">3</a></li>
                                    <li className="page-item"><a className="page-link" href="#">4</a></li>
                                </ul>
                            </nav>

                        </div>

                        <div className="tab-pane fade" id="fiat" role="tabpanel" aria-labelledby="fiat-tab">
                            <h3 className="text-white">New Fiat Listings</h3>

                            <div className="crypto_listing_cnt">
                                <div className="block_listing">
                                    <h5>AED Deposits via UAE Bank Transfer</h5>
                                    <span className="small">2026-08-09</span>
                                </div>
                                <div className="block_listing">
                                    <h5>USD Fiat Channel Open for Verified AGCX Accounts</h5>
                                    <span className="small">2026-08-02</span>
                                </div>
                            </div>

                            <nav className="pagination">
                                <ul className="justify-content-center">
                                    <li className="page-item disabled"><a className="page-link" href="#" tabIndex="-1" ariaDisabled="true">
                                    </a>
                                    </li>
                                    <li className="page-item active"><a className="page-link" href="#">1</a></li>
                                    <li className="page-item"><a className="page-link" href="#">2</a></li>
                                    <li className="page-item"><a className="page-link" href="#">3</a></li>
                                    <li className="page-item"><a className="page-link" href="#">4</a></li>
                                </ul>
                            </nav>

                        </div>

                        <div className="tab-pane fade" id="api" role="tabpanel" aria-labelledby="api-tab">
                            <h3 className="text-white">API Updates</h3>

                            <div className="crypto_listing_cnt">
                                <div className="block_listing">
                                    <h5>AGCX Trading API and WebSocket Documentation</h5>
                                    <span className="small">2026-08-05</span>
                                </div>
                                <div className="block_listing">
                                    <h5>API Rate Limits and Order Connectivity on AGCX</h5>
                                    <span className="small">2026-07-28</span>
                                </div>
                            </div>

                            <nav className="pagination">
                                <ul className="justify-content-center">
                                    <li className="page-item disabled"><a className="page-link" href="#" tabIndex="-1" ariaDisabled="true">
                                    </a>
                                    </li>
                                    <li className="page-item active"><a className="page-link" href="#">1</a></li>
                                    <li className="page-item"><a className="page-link" href="#">2</a></li>
                                    <li className="page-item"><a className="page-link" href="#">3</a></li>
                                    <li className="page-item"><a className="page-link" href="#">4</a></li>
                                </ul>
                            </nav>


                        </div>

                    </div>

                </div>




            </section>
        </>
    )
}

export default AnnouncementList